import Error from './pages/Error'
import Home from './pages/Home'
import Life from './pages/Life'
import Portfolio from './pages/Portfolio'
import Timeline from './pages/Timeline'
import VueRouter from 'vue-router'

const routes = [
  { path: '/', component: Home },
  { path: '/timeline', component: Timeline },
  { path: '/life', component: Life },
  { path: '/portfolio', component: Portfolio },
  { path: '*', component: Error },
]

export default new VueRouter({
  mode: 'history',
  routes,
})
